export const AGENT_REPORT_CHANNEL = "agent";

/** 与 agent 同连接订阅的广播类 channel（服务端约定名） */
export const WS_PUSH_ALL_CHANNEL = "wspush:all";
